import { createFileRoute } from '@tanstack/react-router'
import { requireSuperAdmin } from '@/lib/auth-guards'
import { OverviewTab } from '@/features/dashboard/tabs/overview-tab'

export const Route = createFileRoute('/_authenticated/dashboard/overview')({
  beforeLoad: requireSuperAdmin,
  component: OverviewTab,
})
